export default {
  title: 'Alergeni',
  description:
    'Vă rugăm să rețineți că acest {{product}} poate conține următoarele ingrediente sau produse derivate din acestea:',
  options: {
    dairy: 'Lactate/Lapte',
    eggs: 'Ouă',
    fish: 'Pește',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: 'Arahide',
    sesame: 'Susan',
    shellfish: 'Fructe de mare',
    soy: 'Soia',
    tree_nuts: 'Nuci de copac',
    celery: 'Țelină',
    crustaceans: 'Crustacee',
    lupin: 'Lupin',
    molluscs: 'Moluște',
    mustard: 'Muștar',
    nuts: 'Nuci',
    sulphites: 'Sulfiți',
    almonds: 'Migdale',
    barley: 'Orz',
    brazil_nuts: 'Nuci de Brazilia',
    cashew: 'Caju',
    hazelnuts: 'Alune de pădure',
    kamut: 'Kamut',
    macadamia: 'Nuci macadamia',
    oats: 'Ovăz',
    pecan: 'Pecan',
    pistachios: 'Fistic',
    rye: 'Secară',
    spelt: 'Speltă',
    walnuts: 'Nuci',
    wheat: 'Grâu',
    sugared_drink: 'Băutură îndulcită',
    lentils: 'Linte',
    queensland_nuts: 'Nuci Queensland',
  },
};
